import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { BOTPRESS_INTERACTION_CLASSNAME, BOTPRESS_INTERACTION_ON_MOUNT, BOTPRESS_INTERACTION_TRIGGERS_PREVENT_DEFAULT } from './BotpressInteraction.constants';
import { ActionsPropType } from './BotpressInteraction.types';
import { classNames } from '../../../../utils/classname';
import { isServerSideRendering } from '../../../../utils/gatsby';
import { createComponent } from '../../../foundation/services/components';
import useBotpress from '../../hooks/useBotpress';
var propTypes = {
  actions: ActionsPropType.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  triggerAction: PropTypes.oneOf(['onClick', 'onMount', 'onSubmit'])
};
var defaultProps = {
  children: null,
  className: '',
  triggerAction: 'onClick'
};
export default function BotpressInteraction(_ref) {
  var _classNames2, _createComponent;
  var actions = _ref.actions,
    className = _ref.className,
    children = _ref.children,
    triggerAction = _ref.triggerAction;
  var _useBotpress = useBotpress(),
    addActions = _useBotpress.addActions;
  var actionsWithIds = useMemo(function () {
    return actions.map(function (action) {
      return _objectSpread(_objectSpread({}, action), {}, {
        id: action.id || uuidv4()
      });
    });
  }, [actions]);
  useEffect(function () {
    if (isServerSideRendering()) return;
    if (triggerAction === BOTPRESS_INTERACTION_ON_MOUNT) {
      addActions(actionsWithIds);
    }
  }, []);
  if (triggerAction === BOTPRESS_INTERACTION_ON_MOUNT) {
    var _classNames;
    return createComponent(children, {
      className: classNames((_classNames = {}, _defineProperty(_classNames, BOTPRESS_INTERACTION_CLASSNAME, true), _defineProperty(_classNames, className, className), _classNames))
    });
  }
  function triggerHandler(trigger, e) {
    var _children$props;
    if (trigger in BOTPRESS_INTERACTION_TRIGGERS_PREVENT_DEFAULT) {
      e.preventDefault();
    }
    if (children !== null && children !== void 0 && (_children$props = children.props) !== null && _children$props !== void 0 && _children$props[trigger]) {
      children.props[trigger](e);
    }
    addActions(actionsWithIds);
  }
  return createComponent(children, (_createComponent = {}, _defineProperty(_createComponent, triggerAction, function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", triggerHandler(triggerAction, e));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }()), _defineProperty(_createComponent, "className", classNames((_classNames2 = {}, _defineProperty(_classNames2, BOTPRESS_INTERACTION_CLASSNAME, true), _defineProperty(_classNames2, className, className), _classNames2))), _createComponent));
}
BotpressInteraction.propTypes = propTypes;
BotpressInteraction.defaultProps = defaultProps;